@let numberOfItems = breadcrumbs()?.length || 0;

@if (numberOfItems > 0) {
  <nav aria-label="kruimelpad" class="breadcrumb">
    <ul class="breadcrumb-list" itemscope itemtype="http://schema.org/BreadcrumbList">
      @for (breadcrumb of breadcrumbs(); track $index; let index = $index, last = $last) {
        <li class="breadcrumb-list__item" itemscope itemprop="itemListElement" itemtype="http://schema.org/ListItem">
          <a
            [routerLink]="breadcrumb.url"
            [state]="historyState()"
            itemprop="item"
            class="breadcrumb-list__link"
            routerLinkActive
            [routerLinkActiveOptions]="{ exact: true }"
            ariaCurrentWhenActive="page"
          >
            <span itemprop="name">{{ breadcrumb.label }}</span>
            <meta itemprop="position" content="{{ index + 1 }}" />
          </a>

          @if (!last) {
            <ds-icon name="chevron-right" />
          }
        </li>
      }
    </ul>
  </nav>
}
